<template>
  <div>
    <div class="wrapper">
        <side-bar></side-bar>
      <div class="main-content reculer d-wrapper" :data="sidebarBackground">
       <dashboard-navbar></dashboard-navbar>
        <div class="">
          <fade-transition :duration="200" origin="center top" mode="out-in">
            <!-- your content here -->
            <router-view></router-view>
          </fade-transition>
        </div>
      </div>
    </div>
    <div>
      <AlertLayout />
    </div>
    <content-footer v-if="!$route.meta.hideFooter"></content-footer>
  </div>
</template>

<script>
  import DashboardNavbar from './DashboardNavbar.vue';
   import AlertLayout from '../layout/AlertLayout.vue';
  import ContentFooter from './ContentFooter.vue';
  import { FadeTransition } from 'vue2-transitions';
  import AppConfig from '../constants/AppConfig';

  import io from 'socket.io-client';

  import { mapGetters } from 'vuex';
  import $ from 'jquery';
  import moment from 'moment';

  export default {
    components: {
      DashboardNavbar,
      ContentFooter,
      FadeTransition,
      AlertLayout
    },
    computed: {
      ...mapGetters([
        'loadingScreen',
        'hasAdminRole',
        'hasAssistante',
        'hasMedecinControleRole',
        'hasPatientRole',
        'hasPraticienRole',
        'hasSouscripteurRole',
        'hasGestionnaireRole','customUserRoles']),
    },
    data() {
      return {
        mobileView: true,
        showChangeRoleVue:false,
        opacity:1,
        canCancel:false,
        fullPage: true,
        reveleSide: false,
        brandName: AppConfig.brandName,
        sidebarBackground: 'vue', //vue|blue|orange|green|red|primary,
        dashboardName:localStorage.getItem('dashboardName')
      };
    },
    methods: {

      logOut(){
        let args = {
          user: localStorage.getItem('user')
        };

        let successMessage = this.$i18n.t('message.disconnectMessage');
        let errorMessages = {
          generic: this.$i18n.t('message.genericError'),
          error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
        };
        this.$store.dispatch('logoutHandler',{args, errorMessages, successMessage});
      },
      toggleSidebar() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
        }
      },
      notifier: function(user, message, uuid) {
        // Let's check if the browser supports notifications
        if (!("Notification" in window)) {
            alert("This browser does not support desktop notification");
        }
        // Let's check if the user is okay to get some notification
        else if (Notification.permission === "granted") {
                // If it's okay let's create a notification
            var options = {
              body: message,
              dir : "ltr",
              icon: "/img/brand/favicon/favicon-32x32.png",
              silent: false
            };
            var notification = new Notification(user + " a ajouté une nouvelle alerte",options);
            window.navigator.vibrate([200, 100, 200]);
            notification.onclick = (event) => {
              event.preventDefault(); // prevent the browser from focusing the Notification's tab
              this.$router.push('/alertes?uuid='+uuid);
            }
        }
        // Otherwise, we need to ask the user for permission
        // Note, Chrome does not implement the permission static property
        // So we have to check for NOT 'denied' instead of 'default'
        else if (Notification.permission !== 'denied') {
            Notification.requestPermission(function (permission) {
            // Whatever the user answers, we make sure we store the information
            if (!('permission' in Notification)) {
                Notification.permission = permission;
            }
            // If the user is okay, let's create a notification
            if (permission === "granted") {
              var options = {
                body: message,
                dir : "ltr",
                icon: "/img/brand/favicon/favicon-32x32.png",
                silent: false
              };
              window.navigator.vibrate([200, 100, 200]);
              var notification = new Notification(user + " a ajouté une nouvelle alerte",options);
              notification.onclick = (event) => {
                event.preventDefault(); // prevent the browser from focusing the Notification's tab
                this.$router.push('/alertes?uuid='+uuid);
              }
            }
            });
        }
        // At last, if the user already denied any notification, and you
        // want to be respectful there is no need to bother them anymore.
      }
    },
    created() {
      let self = this;
      $("body").on("mousemove",function(evt) {
        let dernierActivite = new Date(localStorage.getItem('activite'));
        let nouvelleActivite = new Date(moment());
        let difference = Math.abs(Math.round(((nouvelleActivite - dernierActivite) / 1000 ) / 60));
        if (difference <30){
          localStorage.setItem('activite', moment());
        }else{
          evt.preventDefault();
          $("body").off("mousemove");
          if(!window.location.href.includes('/login')){
            localStorage.setItem('ancestor_link', window.location.href);
          }
          self.logOut();
        }
      });
    },
    mounted() {
      this.$store.dispatch('getCustomUserRoles', {});
      localStorage.setItem('activite',moment());

      if ($(window).width() <= 768) {
       $(".d-wrapper").click(function(){
           $(".page-wrapper").removeClass("toggled");
            $(".main-content").removeClass("reculer");
        });
      }

      if (Notification.permission != 'granted'){
        Notification.requestPermission();
      }

      let user = JSON.parse(localStorage.getItem('user')),
        roles = user.roles;
      if(this.hasAssistante){
        let socket = io(AppConfig.socket);
        socket.on("Medsurlink_create_alerte:App\\Events\\AlerteEvent", function(data){
          let audioFile = new Audio('/notifications/notification.mp3');
            audioFile.play();
          this.$store.dispatch('setAlertes', data.alerte);
          this.notifier(data.alerte.creator.name, data.alerte.plainte, data.alerte.uuid)
        }.bind(this));
      }
      else if(this.hasMedecinControleRole){
        let socket = io(AppConfig.socket, {query: user.id});
        socket.on("Medsurlink_update_alerte:App\\Events\\AlerteEvent", function(data){
          if(data.alerte.medecin_id == user.id){
            let audioFile = new Audio('/notifications/notification.mp3');
              audioFile.play();
            this.$store.dispatch('setAlertes', data.alerte);
            this.notifier(data.alerte.creator.name, data.alerte.plainte, data.alerte.uuid)
          }
        }.bind(this));
      }
    }
  };
</script>
<style lang="scss">
</style>
